import React, { useState, useEffect } from 'react';
import { Typography, Steps, Checkbox, Modal, Button, DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import { CheckOutlined, DownloadOutlined } from '@ant-design/icons';
import { isMobileOnly } from 'react-device-detect';
import axios from 'axios';
import env from '../../../environment';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { refreshData } from '../../../store/auth/actions';
import { trace } from '../../../components/tagmanager';
import { useLocation } from 'react-router-dom';
import tagSabadell from '../../../components/tagSabadell';
import _ from 'lodash';

const { Text } = Typography;
const { Step } = Steps;

const Formalization = ({ dataMortgage, operationId, existAppraisal }) => {
	const { t, i18n } = useTranslation();
	const userToken = useSelector((state) => state.auth.token);
	const [feinIssued, setFeinIssued] = useState(undefined);
	const [feinSigned, setFeinSigned] = useState(undefined);
	const [estimatedSignDate, setEstimatedSignDate] = useState(undefined);
	const [finishStep, setFinishStep] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const showPayBoolean = useSelector((state) => state.data.showPay);
	const [checkBoxSigned, setCheckBoxSigned] = useState(dataMortgage?.mortgage?.signed);
	const [mortgageData, setMortgageData] = useState();
	const operations = useSelector((state) => state.auth.operations);
	const nameOperations =
		operations !== undefined &&
		operations.find((operation) => operation.operationId === operationId);
	const rol = useSelector((state) => state.auth.roles);
	const location = useLocation();

	useEffect(() => {
		getMortgageData();
		trace({
			location,
			userToken,
			rol,
			stage: 'formalization',
			operationName: nameOperations && nameOperations.name
		});

		tagSabadell('formalizacion paso 2', i18n.language === 'cat' ? 'ca' : 'es');
	}, []);

	const saveData = (participant, key, value) => {
		axios
			.post(
				`${env.api.url}/v1/mortgages/data/update/${operationId}`,
				{ key, participant, value },
				{ headers: { Authorization: `Bearer ${userToken}` } }
			)
			.then((response) => {
				if (response.data.success) {
					getMortgageData();
					refreshData();
					setCheckBoxSigned(response.data.data.mortgage.signed);
				}
			});

		if (key === 'signed' && value) {
			setIsModalVisible(true);
			tagSabadell('formalizacion confirmacion', i18n.language === 'cat' ? 'ca' : 'es');
		}
		if (key === 'signedDocumentation' && value === true) {
			setFinishStep(true);
		}
	};

	const getMortgageData = async () => {
		try {
			const response = await axios.get(`${env.api.url}/v1/mortgages/data/get/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			});

			const { mortgage } = response.data.data;
			setMortgageData(mortgage);

			const isFeinIssued =
				!_.isNil(_.get(mortgage, 'docFeinIssued')) && _.get(mortgage, 'docFeinIssued') !== false;
			const isFeinSigned =
				!_.isNil(_.get(mortgage, 'signedDocumentation')) &&
				_.get(mortgage, 'signedDocumentation') !== false;

			setFeinIssued(isFeinIssued);
			setFeinSigned(isFeinSigned);
			setEstimatedSignDate(_.get(mortgage, 'estimatedSignDate', false));
		} catch (error) {
			console.error('Error fetching mortgage data:', error);
		}
	};
	const downloadAppraisal = (existAppraisal) => {
		axios
			.get(`${env.api.url}/v1/documents/get-document-url/${existAppraisal.id}?token=${userToken}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				if (response.data.success) {
					window.open(response.data.data.url, '_blank');
				}
			})
			.catch((e) => {
				console.log('error:', e);
			});
	};

	if (feinIssued && !finishStep && !showPayBoolean) {
		tagSabadell('formalizacion paso 2', i18n.language === 'cat' ? 'ca' : 'es');
	}

	if (
		(dataMortgage && dataMortgage.mortgage && dataMortgage.mortgage.signedDocumentation) ||
		finishStep
	) {
		tagSabadell('formalizacion fecha notario', i18n.language === 'cat' ? 'ca' : 'es');
	}

	return (
		<>
			{!showPayBoolean &&
				feinIssued !== undefined &&
				feinSigned !== undefined &&
				mortgageData &&
				estimatedSignDate !== undefined && (
					<div>
						<Text style={{ fontSize: 14, fontWeight: 600, color: '#212121' }}>
							{t('formalization.formalization')}
						</Text>
						<div style={{ marginTop: 24, marginLeft: 15 }}>
							<Steps
								direction="vertical"
								size="small"
								icon={<CheckOutlined />}
								current={feinIssued && feinSigned ? 2 : 1}
								className="StepsFormalization"
								style={{ height: 'auto' }}>
								<Step
									status={feinIssued && feinSigned ? 'finish' : 'process'}
									title={<Text style={{ fontSize: 14 }}>{t('formalization.condictions')}</Text>}
									description={
										<>
											{/* Si la fein no está emitida */}
											{!feinIssued && (
												<Text style={{ fontSize: 14, color: '#212121' }}>
													{t('formalization.workingOnFeinMessage')}
												</Text>
											)}
											{/* Si la fein está emitida y no está firmada */}
											{feinIssued && !feinSigned && (
												<>
													<Text style={{ fontSize: 14, color: '#212121' }}>
														{t('formalization.disponibleFeinMessage')}
													</Text>
													<div style={{ marginTop: 20 }}>
														<Checkbox
															defaultChecked={feinSigned || false}
															onChange={(e) =>
																saveData('mortgage', 'signedDocumentation', e.target.checked)
															}>
															<Text style={{ fontSize: 14, fontWeight: 400, color: '#757575' }}>
																{t('formalization.signedDoc')}
															</Text>
														</Checkbox>
													</div>
												</>
											)}
										</>
									}
								/>
								<Step
									status={checkBoxSigned ? 'finish' : feinIssued && feinSigned ? 'process' : 'wait'}
									title={<Text style={{ fontSize: 14 }}>{t('formalization.finish')}</Text>}
									description={
										<>
											{feinIssued && feinSigned && (
												<>
													<div style={{ width: 'auto' }}>
														<Text style={{ fontSize: 14, color: '#212121' }}>
															{t('formalization.date')}
														</Text>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column' }}>
														<Text
															style={{
																marginTop: isMobileOnly ? 16 : 24,
																fontSize: 12,
																color: '#212121'
															}}>
															{t('formalization.dateEstimated')}
														</Text>
														<div
															style={{
																display: !isMobileOnly && 'flex',
																alignItems: 'center',
																gap: 40
															}}>
															<DatePicker
																aria-label={t('formalization.dateEstimated')}
																format="DD/MM/YYYY"
																defaultValue={
																	estimatedSignDate && estimatedSignDate !== 'Invalid Date'
																		? dayjs(estimatedSignDate)
																		: undefined
																}
																placeholder="00/00/0000"
																style={{ width: isMobileOnly ? '100%' : 280, marginTop: 8 }}
																onChange={(e) => {
																	saveData(
																		'mortgage',
																		'estimatedSignDate',
																		dayjs(e, 'DD-MM-YYYY').format('YYYY-MM-DD')
																	);
																}}
															/>
															<Checkbox
																checked={checkBoxSigned}
																style={{
																	fontSize: 14,
																	color: '#757575',
																	marginTop: isMobileOnly ? 16 : 6
																}}
																onChange={(e) => saveData('mortgage', 'signed', e.target.checked)}>
																{t('formalization.notary')}
															</Checkbox>
														</div>
													</div>
												</>
											)}
										</>
									}
								/>
							</Steps>
						</div>
						<div
							onClick={() => downloadAppraisal(existAppraisal)}
							style={{
								cursor: 'pointer',
								marginTop: feinIssued && feinSigned && isMobileOnly ? 20 : 40,
								borderRadius: 4,
								border: '2px solid #E0E0E0',
								background: '#F5F5F5',
								width: isMobileOnly ? '100%' : '45%',
								flexWrap: 'wrap',
								padding: '12px 16px',
								display: 'flex',
								gap: 8,
								alignItems: 'center',
								justifyContent: 'space-between'
							}}>
							<Text style={{ fontSize: isMobileOnly ? 14 : 16, fontWeight: 500, color: '#212121' }}>
								{t('formalization.appraisalDoc')}
							</Text>
							{isMobileOnly ? (
								<DownloadOutlined style={{ color: '#006DFF' }} />
							) : (
								<Button
									style={{
										borderRadius: 4,
										borderColor: '#004799',
										background: '#F5F5F5',
										color: '#004799'
									}}>
									{t('init.download')}
									<DownloadOutlined />
								</Button>
							)}
						</div>
					</div>
				)}

			<Modal
				className="finish-modal"
				okButtonProps={{
					style: { display: 'none' }
				}}
				cancelText={t('m_common.close')}
				open={isModalVisible}
				title={t('formalization.thanks1')}
				onCancel={() => setIsModalVisible(false)}>
				<div>{t('formalization.thanks3')}</div>
			</Modal>
		</>
	);
};

export default Formalization;
